<template>
  <div>
    <GenderInput
      v-model="innerValue" />
  </div>
</template>
<script>
import GenderInput from '@components/input/GenderInput';
import { mapMutations } from 'vuex';

export default {
  name: 'GenderFilter',
  components: {
    GenderInput
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val !== '') {
          this.$emit('filter', () => (x) => x.gender === val || val === 1);
        } else {
          this.$emit('filter', () => () => true);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
